import { ProductVisibilityType } from "@omni/types/api/product/bff/shared/enums/productVisibilityType.enum";
import { ProductVariant } from "@omni/types/api/product/bff/shared/variants.model";
import { Fragment } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useECommerceProduct } from "../../hooks/useECommerceProduct.hook";
import DropdownFallback from "./dropdownFallback/dropdownFallback.component";
import Swatches from "./swatches/swatches.component";

const Variants = () => {
    const { t } = useGranite();
    const { sku, variantGroups } = useECommerceProduct();

    const variantTypes = Object.keys(variantGroups).filter(
        (variantType) =>
            variantGroups[variantType].filter(
                (variant) =>
                    variant.productVisibilityType !==
                    ProductVisibilityType.NotAvailable
            ).length > 1
    );

    const hasMissingSwatches = (variantGroup: Array<ProductVariant>) => {
        return (
            variantGroup
                .filter(
                    (variant) =>
                        variant.productVisibilityType !==
                        ProductVisibilityType.NotAvailable
                )
                .filter(
                    (variant) =>
                        variant.thumbnailUrl === undefined ||
                        variant.thumbnailUrl === null
                ).length > 0
        );
    };

    if (!variantTypes.length) {
        return <Fragment />;
    }

    return (
        <>
            {variantTypes.map((variantType) => {
                return (
                    <div
                        key={variantType}
                        className="d-flex flex-column p-0 mb-3"
                    >
                        <p className="w-100 mb-2">
                            {t("ecommerce.text.variantSelect")}{" "}
                            {variantType?.toLowerCase()}
                        </p>

                        <div className="d-flex flex-row flex-wrap">
                            {hasMissingSwatches(variantGroups[variantType]) ? (
                                <DropdownFallback
                                    sku={sku}
                                    variantGroup={variantGroups[variantType]}
                                />
                            ) : (
                                <Swatches
                                    sku={sku}
                                    variantGroup={variantGroups[variantType]}
                                />
                            )}
                        </div>
                    </div>
                );
            })}
        </>
    );
};

export { Variants };
